/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';
import { action } from '@ember/object';

import { inject as service } from '@ember/service';
import { post, get } from 'embercom/lib/ajax';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { use } from 'ember-resources/util/function-resource';
import { AsyncData } from 'embercom/resources/utils/async-data';

export default class ZendeskTicketsConfiguration extends Model {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare appService: { app: { currentAdmin: { id: string }; id: string } };

  @attr('number') declare finZendeskUserId: number | undefined;
  @attr('number') declare workflowRulesetId: number;
  @attr('boolean') declare manageAssignmentTrigger: boolean;

  @use ruleset = AsyncData<$TSFixMe>(async () => {
    let ruleset = await this.store.peekRecord('matching-system/ruleset', this.workflowRulesetId);

    if (!ruleset) {
      ruleset = await this.store.findRecord('matching-system/ruleset', this.workflowRulesetId);
    }

    let customBot = ruleset.rulesetLinks.firstObject.object;
    customBot.visualBuilderObject.editorConfig = customBot.config.editorConfig;
    return ruleset;
  });

  get admins() {
    return this.finStandaloneService.zendeskPlatform.zendeskTicketsSetupData.admins;
  }

  get selectedAdminName() {
    let admin = this.admins.filter((admin) => admin.id === this.finZendeskUserId);
    return admin[0]?.name;
  }

  async updateManageAssignmentTrigger(manageAssignmentTrigger: boolean) {
    await post(
      `/ember/standalone/zendesk_configurations/${this.id}/update_manage_assignment_trigger`,
      {
        should_manage: manageAssignmentTrigger,
      },
    );

    this.manageAssignmentTrigger = manageAssignmentTrigger;
  }

  @action async getUsageCounts(): Promise<{
    involvement_count: number;
    last_active?: string;
  }> {
    return get(`/ember/standalone/zendesk_configurations/${this.id}/tickets_usage_counts`, {
      app_id: this.appService.app.id,
      admin_id: this.appService.app.currentAdmin.id,
    });
  }
}
